import { Component } from '@angular/core';
import { SuperClass } from '../../../superclass/SuperClass';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { DashboardDataService } from '../../../services/dashboard-data.service';
import { ClientsService } from '../../../services/clients/clients.service';
import { WsService } from '../../../services/websocket/WsService';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { RouterConst } from '../../../globals/RoutersConst';

@Component({
  selector: 'app-forget-user',
  templateUrl: './forget-user.component.html',
  styleUrls: ['./forget-user.component.css'],
})
export class ForgetUserComponent extends SuperClass {
  username: string;
  macAddress: string;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Admin' },
      {
        label: 'Forget User',
        routerLink: [{ outlets: { sub: [RouterConst.FORGET_USER] } }],
      },
    ]);
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  forgetByUsername() {
    this.http_forgetUserByUsername(this.username, (data: any) => {
      console.log('data11', data);
      this.showSuccessMessage(
        'User with username ' + this.username + ' has been forgotten',
      );
    });
    this.username = '';
  }

  forgetByMAC() {
    this.http_forgetUserByMac(this.macAddress, (data: any) => {
      console.log('data22', data);
      this.showSuccessMessage(
        'User with MAC Address ' + this.macAddress + ' has been forgotten',
      );
    });
    this.macAddress = '';
  }

  reloadData() {}
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/admin/forget-user/forget-user.component.ts